<ng-container *ngIf="media.type === ECreatorMediaTypes.Audio">
  <div class="creator_starter-block">
    <stxt-media-audio [media]="media.value"></stxt-media-audio>
  </div>
</ng-container>

<ng-container *ngIf="media.type === ECreatorMediaTypes.Video">
  <stxt-video
    [src]="media.value"
    [mediaUsage]="EImageUsage.Profile"
    [videoId]="media.media_id"
  ></stxt-video>
</ng-container>

<ng-container *ngIf="media.type === ECreatorMediaTypes.Text">
  <div class="creator_starter-block">
    <p class="creator_starter-block__head"></p>
    <p class="creator_starter-block__body">{{ media.value }}</p>
    <div class="creator_starter-block__button">
      <stxt-button (click)="openChat()" [buttonConfig]="chatButtonConfig">
        <div class="button-content flex items-center">
          <stxt-svg-icon class="chat_svg" [iconConfig]="chatIcon"></stxt-svg-icon>
          <p>{{ chatButtonConfig.text }}</p>
        </div>
      </stxt-button>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="media.type === ECreatorMediaTypes.Image">
  <stxt-image
    [src]="media.value"
    [alt]="media.value"
    [mediaUsage]="EImageUsage.Profile"
    [staggerDelay]="500"
  ></stxt-image>
</ng-container>
